
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 26A11 11 0 017.221 7.221a11.001 11.001 0 0115.56 15.556A10.931 10.931 0 0115 26zm0-13.9a1.665 1.665 0 00-1.664 1.664v7.529a1.663 1.663 0 103.326 0v-7.529A1.665 1.665 0 0015 12.1zm0-5.01a1.663 1.663 0 101.663 1.664A1.665 1.665 0 0015 7.091z","fill":"#222"}})])
          )
        }
      }
    